import React from 'react';

import { BrowserRouter } from 'react-router-dom';

import CookieConsentBanner from 'components/CookieConsentBanner/CookieConsentBanner';
import AnalyticsRouteTracker from 'root/AnalyticsRouteTracker/AnalyticsRouteTracker';
import ReportProblem from 'root/ReportProblem/ReportProblem';
import Router from 'root/Router/Router';
import SentryRouteTracker from 'root/SentryRouteTracker/SentryRouteTracker';

import { useApp } from './App.logic';

const App: React.FC = () => {
  useApp();
  return (
    <BrowserRouter>
      <SentryRouteTracker />
      <AnalyticsRouteTracker />
      <ReportProblem />
      <CookieConsentBanner />
      <Router />
    </BrowserRouter>
  );
};
export default App;
